import React, { FunctionComponent, useState } from "react";
import styles from "./Statement.module.scss";
import StatementProps from "./StatementProps.interface";

import DynamicHeading from "components/DynamicHeading/DynamicHeading";
import Paragraph from "components/Paragraph/Paragraph";

const Statement: FunctionComponent<StatementProps> = (props): JSX.Element => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.inner}>
                {/* Headline */}
                {props.content.heading ? (
                    <DynamicHeading className={styles.heading} headlineSize="H4" headlineWeight="H4">{props.content.heading}</DynamicHeading>
                ) : null}

                {/* Text */}
                {props.content.bodyText ? (
                    <Paragraph className={styles.text} innerHTML={props.content.bodyText} />
                ) : null}
            </div>
        </div>
    );
};

export default Statement;